<template>
  <div class="projbid-reply-preview">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="panel-box">
      <ProjectViewSummary class="viewSummary" :project="project" />
    </div>
    <div class="eb-line"></div>
    <div class="rule-answer-view">
      <ProjRuleAnswerViewList :ruleAnswerList="ruleAnswerList" />
    </div>
    <ProjectViewHandsontable class="panel-box" :title="projectHandsontableTitle" :hotSettings="shoppingListHotSettings" :total="reply.quoteMin" :isTotalShow="true" />
    <div class="eb-line"></div>
    <ProjectViewPreText class="panel-box" :title="projectViewCommentTitle" :content="project.projectComment" />
    <div class="eb-line"></div>
    <ProjectViewPreText class="panel-box" :title="projectViewquoteStatementTitle" :content="reply.quoteStatement" />
    <div class="eb-line"></div>
    <div class="eb-button-group" v-if="!(reply.quoteStatus==2||reply.quoteStatus==1)" :disabled="reply.quoteStatus != 9 ">
      <el-button v-if="btnIsShow == 1" :loading="isRevocationReply" class="eb-button-group-btn eb-button-orange eb-button-big" @click="revocationReply">撤回报价</el-button>
    </div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ProjectViewSummary from '@/components/project/common/ProjectViewSummary';
import ProjRuleAnswerViewList from '@/components/project/common/rule-answer-view/ProjRuleAnswerViewList';
import ProjectViewHandsontable from '@/components/project/common/ProjectViewHandsontable';
import ProjectViewPreText from '@/components/project/common/ProjectViewPreText';
import { detailProject, ravocationProject } from '@/services/proj/bid-project-service';
import { handleProjRuleAnswerList } from '@/services/proj/project-service';
import { listSupplier } from '@/services/proj/bid-shopping-list-service';
import { listAnswer } from '@/services/proj/bid-rule-answer-service';
export default {
  name: 'ProjBidReplyDetail',
  components: {
    ebHeader,
    ebBreakCrumb,
    ProjectViewSummary,
    ProjRuleAnswerViewList,
    ProjectViewHandsontable,
    ProjectViewPreText
  },
  filters: {},
  data() {
    return {
      projectId: this.$route.params.projectId,
      replyId: this.$route.params.replyId,
      user: this.$store.state.user.userInfo,
      createId: this.$route.params.createId,
      project: {},
      ruleAnswerList: [],
      isRevocationReply: false,
      reply: {},
      btnIsShow: 1, // 1显示撤回报价0不显示
      projectHandsontableTitle: {
        number: '1',
        text: '分项报价表'
      },
      projectViewCommentTitle: {
        number: '2',
        text: '报价表备注'
      },
      projectViewquoteStatementTitle: {
        number: '3',
        text: '报价声明'
      },
      shoppingListHotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['名称', '描述', '单位', '数量', '单价(投标方填写)', '总价', '备注'],
        renderAllRows: true,
        fillHandle: false,
        data: [],
        columns: [
          {
            data: 'productName',
            type: 'text',
            width: 90,
            readOnly: true
          },
          {
            data: 'productDesc',
            type: 'text',
            width: 430,
            readOnly: true
          },
          {
            data: 'productUnit',
            type: 'text',
            width: 40,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'productNum',
            width: 70,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'supplierPrice',
            width: 140,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'supplierSubtotal',
            width: 110,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'remark',
            width: 70,
            renderer: 'html',
            className: 'htCenter',
            readOnly: true
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      if (this.user.roleid + '' === '9' && this.createId !== this.user.userid) {
        this.btnIsShow = 0;
      }
      try {
        let [{ data: data1 }, { data: data2 }, { data: data3 }] = await Promise.all([
          detailProject(this.projectId, this.replyId), // 获取招标项目详情，包含shopList,project
          listSupplier(this.projectId, this.createId), // 获取应答shoplist
          listAnswer(this.projectId, this.createId) // 获取获取规则应答明细
        ]);
        if (data1.returnCode === '01') {
          this.project = data1.project;
          this.reply = data1.reply;
        } else {
          throw new Error('加载项目详情失败！');
        }
        if (data2.returnCode === '01') {
          this.shoppingListHotSettings.data = data2.supplierList;
        } else if (data2.returnCode === '00') {
        } else {
          throw new Error('加载应答清单失败');
        }
        if (data3.returnCode === '01') {
          this.ruleAnswerList = handleProjRuleAnswerList(data3.ruleList);
          this.changeTitleNumber(parseInt(this.ruleAnswerList.length));
        } else if (data2.returnCode === '00') {
        } else {
          throw new Error('加载应答清单失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    changeTitleNumber: function(number) {
      this.projectHandsontableTitle.number = number + 1;
      this.projectViewCommentTitle.number = number + 2;
      this.projectViewquoteStatementTitle.number = number + 3;
    },
    async revocationReply() {
      this.$ebConfirm('确认要撤回项目吗?')
        .then(() => {
          this.ravocationProjectService();
        })
        .catch(() => {});
    },
    async ravocationProjectService() {
      this.isRevocationReply = true;
      try {
        let { data } = await ravocationProject('quote', this.projectId, this.replyId, this.createId);
        if (data.returnCode === '01') {
          this.$router.push('/projbid/quoted/list');
        } else {
          this.$message.error(data.message);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.isRevocationReply = false;
    }
  }
};
</script>
<style lang="less">
</style>
